import { render } from "./OwnedTableHeader.vue?vue&type=template&id=252398b5&scoped=true"
import script from "./OwnedTableHeader.vue?vue&type=script&lang=js"
export * from "./OwnedTableHeader.vue?vue&type=script&lang=js"

import "./OwnedTableHeader.vue?vue&type=style&index=0&id=252398b5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252398b5"]])

export default __exports__